import type { FC } from 'react';
import { useState } from 'react';
import type { TChatProps } from '@components/Molecules/Chat/Chat.types';
import classNames from 'classnames';
import { useStoreState } from 'easy-peasy';
import { ChatMessage } from '@components/Molecules/Chat/_partials/ChatMessage';
import { ChatFooter } from '@components/Molecules/Chat/_partials/ChatFooter';
import { ChatToggle } from '@components/Molecules/Chat/_partials/ChatToggle';
import { ChatSkeleton } from '@components/Molecules/Chat/_partials/ChatSkeleton';
import { ChatHeader } from '@components/Molecules/Chat/_partials/ChatHeader';
import { useMessages } from '@components/Molecules/Chat/_hooks/use-messages';
import { feedbacksLoadingSelector } from '@model/Candidate/Candidate.selectors';

export const Chat: FC<TChatProps> = ({ className }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const isLoading = useStoreState(feedbacksLoadingSelector);
  const messages = useMessages();

  const wrapperClassNames = classNames(
    'ev-chat',
    {
      'ev-chat--open': isOpen,
    },
    className,
  );

  const onOpenToggle = (): void => setIsOpen(!isOpen);

  return (
    <div className={wrapperClassNames}>
      <ChatHeader onToggle={onOpenToggle} />
      <ChatToggle isOpen={isOpen} onToggle={onOpenToggle} />

      {isLoading ? (
        <ChatSkeleton />
      ) : (
        <div className="ev-chat__messages-list">
          {messages.map(message => (
            <ChatMessage key={message.leftAt} message={message} />
          ))}
        </div>
      )}

      <ChatFooter />
    </div>
  );
};
